import { selector } from '@/lib/selectors';
import { configurationCompanySelector } from '@/domain/companies/companiesLeafSelectors';
import { currentCompanyIdSelector } from '@/domain/router/routerLeafSelectors';

// The settings pages read the configuration company from the store, which keeps the previous company's record until
// the next one arrives; their forms would show and save that company's values.
export const waitCompanySettingsRouteLoadedSelector = selector(
  configurationCompanySelector,
  currentCompanyIdSelector,
  (configurationCompany, companyId: string | null) => companyId !== null && configurationCompany.id === companyId,
);
